import api from "@/lib/api";

export async function uploadToCloudinary(file) {
  const { data: sig } = await api.get("/admin/cloudinary/signature");
  const form = new FormData();
  form.append("file", file);
  form.append("api_key", sig.api_key);
  form.append("timestamp", sig.timestamp);
  form.append("signature", sig.signature);
  form.append("folder", sig.folder);
  const res = await fetch(`https://api.cloudinary.com/v1_1/${sig.cloud_name}/image/upload`, {
    method: "POST",
    body: form,
  });
  const json = await res.json();
  if (!json.secure_url) throw new Error(json.error?.message || "Upload failed");
  return json.secure_url;
}
